/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Drop_FrameInputs */

const en_subtitle_export_drop_frame = /** @type {(inputs: Subtitle_Export_Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dropframe`)
};

const fr_subtitle_export_drop_frame = /** @type {(inputs: Subtitle_Export_Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cadre de chute`)
};

const de_subtitle_export_drop_frame = /** @type {(inputs: Subtitle_Export_Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dropframe`)
};

const it_subtitle_export_drop_frame = /** @type {(inputs: Subtitle_Export_Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telaio a caduta`)
};

const ru_subtitle_export_drop_frame = /** @type {(inputs: Subtitle_Export_Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dropframe`)
};

const es_subtitle_export_drop_frame = /** @type {(inputs: Subtitle_Export_Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dropframe`)
};

const zh_cn2_subtitle_export_drop_frame = /** @type {(inputs: Subtitle_Export_Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`掉帧`)
};

const ja_subtitle_export_drop_frame = /** @type {(inputs: Subtitle_Export_Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ドロップフレーム`)
};

const hi_subtitle_export_drop_frame = /** @type {(inputs: Subtitle_Export_Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ड्रॉपफ्रेम`)
};

const pt_pt2_subtitle_export_drop_frame = /** @type {(inputs: Subtitle_Export_Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dropframe`)
};

/**
* | output |
* | --- |
* | "Dropframe" |
*
* @param {Subtitle_Export_Drop_FrameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_drop_frame = /** @type {((inputs?: Subtitle_Export_Drop_FrameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Drop_FrameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_drop_frame(inputs)
	if (locale === "de") return de_subtitle_export_drop_frame(inputs)
	if (locale === "it") return it_subtitle_export_drop_frame(inputs)
	if (locale === "ru") return ru_subtitle_export_drop_frame(inputs)
	if (locale === "es") return es_subtitle_export_drop_frame(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_drop_frame(inputs)
	if (locale === "ja") return ja_subtitle_export_drop_frame(inputs)
	if (locale === "hi") return hi_subtitle_export_drop_frame(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_drop_frame(inputs)
	return en_subtitle_export_drop_frame(inputs)
});